const firebaseConfig = {
   apiKey: "AIzaSyDskKpk8IFFYm7jz9C9MzBq-9b_NJTk0CE",
    authDomain: "creative-agency-website-c1be4.firebaseapp.com",
    databaseURL: "https://creative-agency-website-c1be4.firebaseio.com",
    projectId: "creative-agency-website-c1be4",
    storageBucket: "creative-agency-website-c1be4.appspot.com",
    messagingSenderId: "483284642643",
    appId: "1:483284642643:web:d09d3c4aac31d39cbbcfa6",
    measurementId: "G-PWZTW15FHS"
  };
export default firebaseConfig;